window.addEventListener('DOMContentLoaded', function(){

    const categoryToggles = document.querySelectorAll('button.category-toggle');

    if( categoryToggles ){
        categoryToggles.forEach( button => button.addEventListener( 'click', e => {
            e.currentTarget.closest('.category-item').classList.toggle('open');
        }));
    }

    // toggle categories on mobile
    let is_open = false;
    let mobile_breakpoint = 768;
    const category_button = document.querySelector('#toggle-categories');
    const category_sidebar = document.querySelector('.sidebar');

    if( category_button ){
        category_button.addEventListener('click', () => {

            if (! document.startViewTransition) {
                return toggleSidebar();
            }

            // Transition API
            // https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
            // https://www.youtube.com/watch?v=jZiZs8cZAKU
            // https://developer.chrome.com/docs/web-platform/view-transitions/
            return document.startViewTransition(() => toggleSidebar() );

        } );

        // hide/show button or sidebar on resize
        window.addEventListener('resize', sidebarHandleResize );
    }

    function toggleSidebar(){
        is_open = ! is_open;

        let text = true == is_open ? "Hide Categories" : "Show Categories";
        let display = true == is_open ? "Block" : "None";

        category_button.innerText = text;
        category_sidebar.style.display = display;
        
    }
    
    function sidebarHandleResize(){
        
        is_open = false;
        category_button.innerText = "Show Categories";
        
        if(window.innerWidth < mobile_breakpoint ){
            category_button.style.display = "inline-block";
            category_sidebar.style.display = "none";
        }else{
            category_button.style.display = "none";
            category_sidebar.style.display = "block";
        }
        
    }

})